import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from "yup";
import FacebookLogin, { FacebookLoginClient } from '@greatsumini/react-facebook-login';
import { useGoogleLogin } from '@react-oauth/google';
import { accountService } from '../functions/loginApi';
import { TailSpin } from 'react-loader-spinner';
import { authService } from '../functions/authenticate';

import '../scss/RegisterMember.scss';

const Login = ({ setLogin, userID, setUserID, setUserName, authToken, setAuthToken, marathonStartDate }) => {
    const [open, setOpen] = useState(true);
    const [loading, setLoading] = useState(false);
    const [signInErr, setSignInErr] = useState(false);
    const [signInMessage, setSignInMessage] = useState('');
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {

        let token = localStorage.getItem('authToken');
        if(token === null || token === undefined || token === "") {
            console.log(token);
        } else {
            setAuthToken(token);
        }

    }, []);

    useEffect(() => {
        if(authToken && authToken!==null && authToken!=='')
        {
            // console.log(authToken);
            authService.validateAuthToken(authToken)
                .then(response => {
                    // console.log(response);
                    setAuthToken(response.body.token);
                    localStorage.setItem('authToken', response.body.token);
                    // navigate("/Profile/myRun");

                    localStorage.setItem('device', searchParams.get('platform')===null ? '' : searchParams.get('platform'));

                    if(searchParams.get('mode') && searchParams.get('mode')!==null && searchParams.get('mode')==='editRegistration') {

                        // alert(searchParams.get('paymentID'));

                        accountService.getRegistrationByPaymentID(searchParams.get('paymentID'), authToken)
                            .then(response => {

                                // alert('ok');
                                // console.log(response);

                                if(response.status) {
                                    let runners = response.body.runner;
                                    let newRunners = [];

                                    runners.map((data) => {
                                        // console.log(data);
                    
                                        const obj = {
                                            individualID: data.individualID,
                                            paymentID: data.paymentID,
                                            fullname: data.fullname,
                                            gender: data.gender,
                                            email: data.email,
                                            bibName: data.bib_name,
                                            dob: data.dob,
                                            nationality: data.nationality,
                                            mykad: data.mykad,
                                            contact: data.phone,
                                            emergencyName: data.emergency_name,
                                            emergencyContact: data.emergency_contact,
                                            medicalAttention: data.medical_attention,
                                            category: data.race_cat,
                                            categoryType: data.race_cat_type,
                                            tshirt_size: data.tshirt_size,
                                            finisher: data.finisher_size,
                                            racePackCollection: data.racePackCollection,
                                            deliveryAddress : data.deliveryAddress,
                                            deliveryPostcode : data.deliveryPostcode,
                                            deliveryCity : data.deliveryCity,
                                            deliveryState : data.deliveryState,
                                            deliveryCountry : data.deliveryCountry,
                                        };
                                        newRunners.push(obj);
                                    });
                    
                                    localStorage.setItem('editList', JSON.stringify(newRunners));
                    
                                    var updateToken =  authService.encryptUpdateToken(userID);
                                    // console.log(updateToken);


                                    navigate('/EditRegistration?updateToken=' + updateToken);

                                }

                                
                            })
                            .catch(err => {
                                console.log(err);
                                setSignInMessage('Ops... Something went wrong. Please try again later.');
                                setSignInErr(true);
                                setLoading(false);
                            });

                    } else if(searchParams.get('mode') && searchParams.get('mode')!==null && searchParams.get('mode')==='merchant') {
                        // alert("Go to Eshop");
                        navigate("/Shop");
                    } else {
                        navigate("/Register");
                    }

                })
                .catch(err => {
                    console.log(err);
                })
        }
    }, [authToken]);

    useEffect(() => {
        if(searchParams.get('individualID') && searchParams.get('individualID')!==null && searchParams.get('individualID')!=='')
        {
            setLoading(true);
            // alert(window.location.href);
            accountService.mobileSignIn(searchParams.get('individualID') , searchParams.get('tempID'))
                .then(response => {
                    // console.log(response);
                    updateLoginStatus(response, '');
                })
                .catch(err => {
                    console.log(err);
                    setSignInMessage('Ops... Something went wrong. Please try again later.');
                    setSignInErr(true);
                    setLoading(false);
                });
        }
    }, [searchParams]);

    const initialValues = {
        firstname : '',
        lastname : '',
        name : '',
        email : '',
        password : '',
        googleId : ''
    };
    const [formData, setFormData] = useState(initialValues);
    const SignInSchema = Yup.object().shape({
        email: Yup.string().email().required("Email is required"),
      
        password: Yup.string()
          .required("Password is required")
          .min(8, "Password is too short - should be 8 chars minimum"),
    });

    const submitForm = (values) => {
        // console.log(values);
        setSignInErr(false);

        setFormData((prevState) => ({
            googleId : '',
            email : values.email,
            password : values.password,
            firstname : '',
            lastname : '',
            name : ''
        }));
    };

    // verify login when the email formData is updated
    useEffect(() => {
        // console.log(formData);
        if(formData.email !=='' && formData.password !=='')
        {
            setLoading(true);
            accountService.signIn(formData)
                .then(response => {
                    // console.log(response);
                    updateLoginStatus(response, '');
                })
                .catch(err => {
                    console.log(err);
                    setSignInMessage('Ops... Something went wrong. Please try again later.');
                    setSignInErr(true);
                    setLoading(false);
                });
        }
        else if(formData.email !== '' && formData.googleId !== '')
        {
            // console.log(formData);
            setGoogleLoading(true);
            accountService.signIn(formData)
                .then(response => {
                    console.log(response);
                    updateLoginStatus(response, 'Google');
                })
                .catch(err => {
                    console.log(err);
                    setSignInMessage('Ops... Something went wrong. Please try again later.');
                    setSignInErr(true);
                    setLoading(false);
                });
        }
    }, [formData]);
    function updateLoginStatus(response, type) {
        if(response.status) {
            let user = response.body.user;
            setUserID(user.individualID);
            localStorage.setItem('userID', user.individualID);
            let fname = user.firstname === null ? '' : user.firstname;
            let lname = user.lastname === null ? '' : user.lastname
            let name = fname + ' ' + lname;
            setUserName(name);
            localStorage.setItem('userName', name);
            
            setLogin(true);
            setAuthToken(response.body.token);
            localStorage.setItem('authToken', response.body.token);
            
            if(type === 'Google')setGoogleLoading(false);
            else setLoading(false);
            
            // navigate("/Profile/myRun");
            
        }
        else
        {
            setSignInMessage(response.body.message);
            setSignInErr(true);

            if(type === 'Google')setGoogleLoading(false);
            else setLoading(false);
        }
    }


    // Facebook Login
    const FacebookAppID = process.env.REACT_APP_FACEBOOK_APP_ID;
    const responseFacebook = (response) => {
        // console.log(response);
        // Login failed
        if (response.status === "unknown") {
            setLogin(false);
            setSignInMessage(response.body.message);
            setSignInErr(true);
            return false;
        }

        if (response.accessToken) {
            setLogin(true);
        } else {
            setLogin(false);
            setSignInMessage(response.body.message);
            setSignInErr(true);
        }
    };
    const responseFacebookProfile = (response) => {
        console.log(response);
        // setData(response);
        // setPicture(response.picture.data.url);

        FacebookLoginClient.getProfile((response) => {
            console.log(response.id, response.name, response.email);
        });
    };


    // // Google Login
    const [GoogleLoading, setGoogleLoading] = useState(false);
    //     const initClient = () => {
    //           gapi.client.init({
    //           clientId: GoogleClientID,
    //           scope: ''
    //         });
    //     };
    //     gapi.load('client:auth2', initClient);
    // });
    // const onGoogleSuccess = (res) => {
    //     // console.log('success:', res.profileObj);

    //     setFormData((prevState) => ({
    //         googleId : res.profileObj.googleId,
    //         email : res.profileObj.email,
    //         firstname : res.profileObj.givenName,
    //         lastname : res.profileObj.familyName,
    //         name : res.profileObj.name,
    //         password : ''
    //     }));

    //     // console.log(formData);
    //     // setUserName(res.profileObj.givenName + ' ' + res.profileObj.familyName);
    // };
    // const onGoogleFailure = (err) => {
    //     console.log('failed:', err);
    //     setSignInMessage("Sign in Failed. Please try again.");
    //     setSignInErr(true);
    // };
    const GoogleOnSuccess = useGoogleLogin({
        onSuccess: async tokenResponse => {
            // console.log('token:', tokenResponse);
            setGoogleLoading(true);
            accountService.getGoogleUserInfo(tokenResponse)
                .then(res => {
                    // console.log(res);
                    setGoogleLoading(false);
                    setFormData((prevState) => ({
                        googleId : res.data.sub,
                        email : res.data.email,
                        firstname : res.data.given_name,
                        lastname : res.data.family_name,
                        name : res.data.name,
                        password : ''
                    }));
                })
                .catch(error => {
                    console.log(error);
                    setGoogleLoading(false);
                })
        },
        onError: async res => {
            console.log(res);
            setGoogleLoading(false);
        }
    });


    // Redirect to sign up page
    const goSignUp = (e) => {
        e.preventDefault();
        navigate('/RegisterMember');
    }

    // Redirect to forgot password page
    const forgotPassword = (e) => {
        e.preventDefault();
        navigate('/ForgotPassword');
    }


    return (
        <Container fluid="lg" className='wrapper'>
            <Row className="RegisterMemberRow">

                <h1>Login</h1>

                {signInErr && (
                    <Col md={12} xs={12}>
                        <Alert variant="danger" onClose={() => setSignInErr(false)} dismissible>
                            {signInMessage}
                        </Alert>
                    </Col>
                )}

                <Col xs={12} md={6} className="section left-divider">

                    {open? (
                        <Formik
                        initialValues={initialValues}
                        validationSchema={SignInSchema}
                        onSubmit={submitForm}
                    >
                        {({
                            values,
                            handleChange,
                            handleSubmit,
                            errors,
                            touched,
                            handleBlur,
                            isValid,
                            dirty
                        }) => (
                    
                            <Form noValidate onSubmit={handleSubmit}>

                                <Row className="mb-3">
                                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            required
                                            name="email"
                                            type="email"
                                            placeholder="abc@gmail.com"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.email}
                                            isValid={touched.email && !errors.email}
                                            isInvalid={!!errors.email}
                                            
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Row className="mb-3">
                                    <Form.Group as={Col} md="12" controlId="validationCustom02">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control
                                            required
                                            name="password"
                                            type="password"
                                            placeholder="Password"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.password}
                                            isValid={touched.password && !errors.password}
                                            isInvalid={!!errors.password}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Row className="p-3">
                                    <Button type="submit" size="lg" className="red-button  d-flex justify-content-center">
                                        Login &nbsp;
                                        <TailSpin
                                            height="30"
                                            width="30"
                                            color="#ccc"
                                            ariaLabel="tail-spin-loading"
                                            radius="1"
                                            wrapperStyle={{}}
                                            wrapperClass="loader"
                                            visible={loading}
                                        />
                                    </Button>
                                </Row>

                                <Row className="p-3 mb-3 text-center">
                                    <p>You don't have an account? <a href="*" onClick={goSignUp}>Sign Up</a></p>
                                    <p>Forgot your password? <a href="*" onClick={forgotPassword}>Forgot Password</a></p>
                                </Row>

                            </Form>

                        )}
                    </Formik>
                    ) : (
                        <>
                            <Row>
                                <h1 style={{paddingLeft:"0", marginLeft:"0"}}>We are upgrading the system at the moment. Shall be back shortly</h1>
                                {/* <img src={`${process.env.PUBLIC_URL}/images/2024_promo_banner.jpg`} alt=""  /> */}
                            </Row>
                        </>
                    )}
                                
                    

                </Col>

                <Col xs={12} md={6} className="section">
                    
                    <div className="loginButtonSection">

                        {/* <Row>
                            <img src={`${process.env.PUBLIC_URL}/images/register1.png`} alt=""  />
                        </Row> */}

                        <Row>
                            <Col sm={12} md={12} className='loginRightSection p-4' >
                                <h5>Join Us</h5>
                                <h1>{marathonStartDate}</h1>
                                <h4>Padang Merdeka, Kuching, Sarawak</h4>
                            </Col>
                        </Row>

                        {/* <Row className="mb-3 text-center">
                            <h5>Sign in without typing</h5>
                            <hr />
                        </Row>

                        <Row className="mb-4">
                            <FacebookLogin
                                btnContent="LOGIN With Facebook"
                                appId={FacebookAppID}
                                autoLoad={false}
                                fields="name,email,picture"
                                scope="public_profile,email,user_friends"
                                onSuccess={responseFacebook}
                                onFail={responseFacebook}
                                onProfileSuccess={responseFacebookProfile}
                                render={(renderProps) => (
                                    <button id="facebook-btn" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                        <div className="btn-wrap">
                                            <div className="logo">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" fill="url(#pattern0)"></rect><defs><pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1"><use href="#image0_213_540" transform="scale(0.00769231)"></use></pattern><image id="image0_213_540" width="130" height="130" href="data:image/png;base64,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"></image></defs></svg>     
                                            </div>
                                            <span>Login with Facebook</span>
                                        </div>
                                    </button>
                                )}
                            />

                            {login && (
                                    <div className="card">
                                    <div className="card-body">
                                        <img className="rounded" src={picture} alt="Profile" />
                                        <h5 className="card-title">{data.name}</h5>
                                        <p className="card-text">Email ID: {data.email}</p>
                                        <a href="#" className="btn btn-danger btn-sm" onClick={FacebookLogout}>
                                        Logout
                                        </a>
                                    </div>
                                    </div>
                                )
                            }
                        </Row> */}

                        {/* <Row className="mb-4">
                            <GoogleLogin
                                clientId={GoogleClientID}
                                buttonText="Sign in with Google"
                                onSuccess={onGoogleSuccess}
                                onFailure={onGoogleFailure}
                                cookiePolicy={'single_host_origin'}
                                isSignedIn={true}
                                render={(renderProps) => (
                                    <button id="google-btn" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                        <div className="btn-wrap">
                                            <div className="logo">
                                                <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><g fill="#000" fillRule="evenodd"><path d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z" fill="#EA4335"></path><path d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z" fill="#4285F4"></path><path d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z" fill="#FBBC05"></path><path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z" fill="#34A853"></path><path fill="none" d="M0 0h18v18H0z"></path></g></svg>
                                            </div>
                                            <span>Login with Google &nbsp;</span>
                                            <TailSpin
                                                height="18"
                                                width="18"
                                                color="#ccc"
                                                ariaLabel="tail-spin-loading"
                                                radius="1"
                                                wrapperStyle={{}}
                                                wrapperClass="loader"
                                                visible={GoogleLoading}
                                            />
                                        </div>
                                    </button>
                                )}
                            />
                        </Row> */}
                    
                        {/* <Row className="mb-4">
                            <button id="google-btn" onClick={() => {setGoogleLoading(true); GoogleOnSuccess();}}>
                                <div className="btn-wrap">
                                    <div className="logo">
                                        <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><g fill="#000" fillRule="evenodd"><path d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z" fill="#EA4335"></path><path d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z" fill="#4285F4"></path><path d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z" fill="#FBBC05"></path><path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z" fill="#34A853"></path><path fill="none" d="M0 0h18v18H0z"></path></g></svg>
                                    </div>
                                    <span>Login with Google &nbsp;</span>
                                    <TailSpin
                                        height="18"
                                        width="18"
                                        color="#ccc"
                                        ariaLabel="tail-spin-loading"
                                        radius="1"
                                        wrapperStyle={{}}
                                        wrapperClass="loader"
                                        visible={GoogleLoading}
                                    />
                                </div>
                            </button>
                        </Row> */}
                    </div>

                </Col>
            
            </Row>
        </Container>
    );
}

export default Login;